module.exports = __webpack_public_path__ + "static/media/CircularStd-Medium.35964d63.eot";